/**
 * General Medicine Consultations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";

// States
const state = {
    manuscrits: [],
    manuscrit: {}
};

// Getters
const getters = {
    manuscrits: state => {
        return state.manuscrits
    },

    manuscrit: state => {
        return state.manuscrit
    }
};

// Actions
const actions = {
    getManuscrits(context, payload) {
        function successCallback(response) {
            context.commit('getManuscritsHandler', { consultations: response.data.consultations });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Manuscrit.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getManuscrit(context, payload) {
        function successCallback(response) {
            context.commit('getManuscritHandler', { consultation: response.data.consultation });
            context.commit('getMedicalFileHandler', { file: response.data.consultation.dossier });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Manuscrit.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createManuscrit(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'consultation-manuscrit', params: { consultation: response.data.consultation.slug } });


        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.Consultation.Manuscrit.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
        // makeApiRequest(payload.args, apiModel.Consultation.General.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateManuscrit(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            store.dispatch('findAndRemove', {name: 'consultation-manuscrit' });

            router.push({ name: 'consultation-manuscrit', params: { consultation: response.data.consultation.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.Consultation.Manuscrit.Update, localToken, successCallback, errorCallback, payload.errorMessages,true);

        let url = AppConfig.apiUrl + apiModel.Consultation.Manuscrit.Create.url + '/' + payload.consultation;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
        },

    deleteManuscrit(context, payload) {
        function successCallback(response) {
            // context.commit('deleteGeneralConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.consultation.dossier.slug } }).href) +"#fichiersExternes");
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Manuscrit.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    archieveManuscrit(context, payload) {
        function successCallback(response) {
            context.commit('archieveManuscritHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getManuscritHandler', { consultation: response.data.resultat });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Manuscrit.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitManuscrit(context, payload) {
        function successCallback(response) {
            context.commit('transmitManuscritHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getManuscritHandler', { consultation: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Manuscrit.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    reactiveManuscrit(context, payload) {
        function successCallback(response) {
            context.commit('reactiveManuscritHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getManuscritHandler', { consultation: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Manuscrit.Reactive, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getManuscritsHandler(state, { consultations }) {
        // Update generalConsultations state
        state.manuscrits = consultations;
    },

    getManuscritHandler(state, { consultation }) {
        // Update generalConsultation state
        state.manuscrit = consultation;
    },

    updateManuscritFileHandler(state,{files}){
        state.manuscrit.files = files
    },

    deleteManuscritHandler(state, { index, successMessage }) {
        Vue.swal(
            payload.successMessage,
            '',
            'success'
        );

    },

    archieveManuscritHandler(state, { index, successMessage }) {
        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    reactiveManuscritHandler(state, { index, successMessage }) {

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitManuscritHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-generals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}